import { isDwbEnabledAtSite, isProgramEnabledAtSite } from './siteProgramAccess'
import {
  DEFAULT_K8_REPORT_UNIT_SECTION,
  K8_REPORT_UNIT_SECTION,
  REPORT_BASE_PATH,
  REPORT_VARIANT,
} from 'pages/LessonCompletionReport/flag.on/constants'

export const getReportVariantFromPathname = pathname => {
  const cleanPath = (pathname || '').split('?')[0].split('#')[0]
  const parts = cleanPath.split('/').filter(Boolean)
  if (parts[0] !== 'reports') return REPORT_VARIANT.K8
  if (parts[1] === REPORT_VARIANT.DWB) return REPORT_VARIANT.DWB
  return REPORT_VARIANT.K8
}

export const isDwbReportPathname = pathname =>
  getReportVariantFromPathname(pathname) === REPORT_VARIANT.DWB

/**
 * Standalone-DWB and HS+DWB sites use /reports/dwb; K8+DWB and non-DWB use k8 core_units.
 */
export const resolveLessonCompletionReportPathForSite = (site, siteId) => {
  const hasK8 = isProgramEnabledAtSite(site, 'K8')
  const hasDwb = isDwbEnabledAtSite(site)

  if (!hasDwb || (hasDwb && hasK8)) {
    return `${REPORT_BASE_PATH.k8}/${DEFAULT_K8_REPORT_UNIT_SECTION}?site=${siteId}`
  }

  return `${REPORT_BASE_PATH.dwb}?site=${siteId}`
}

const isGradeLikeSlug = slug =>
  slug?.startsWith('grade-') || slug?.startsWith('tier2-')

export const buildReportPath = ({
  variant = REPORT_VARIANT.K8,
  unitSection = DEFAULT_K8_REPORT_UNIT_SECTION,
  gradeSlug = '',
}) => {
  const gradeParam = gradeSlug ? `/${gradeSlug}/` : ''

  if (variant === REPORT_VARIANT.DWB) {
    return `${REPORT_BASE_PATH.dwb}${gradeParam}`
  }

  return `${REPORT_BASE_PATH.k8}/${unitSection}${gradeParam}`
}

export const parseLessonCompletionReportPathname = pathname => {
  const parts = pathname?.split('/').filter(Boolean) || []
  const variant = getReportVariantFromPathname(pathname)

  if (variant === REPORT_VARIANT.DWB) {
    const thirdSeg = parts[2]
    const gradeSlugSegment = isGradeLikeSlug(thirdSeg) ? thirdSeg : null
    return {
      variant,
      unitSection: K8_REPORT_UNIT_SECTION.SPECIALIZED_UNITS,
      gradeSlugSegment,
    }
  }

  const thirdSeg = parts[2]
  const fourthSeg = parts[3]
  const isUnitSection =
    thirdSeg === K8_REPORT_UNIT_SECTION.CORE_UNITS ||
    thirdSeg === K8_REPORT_UNIT_SECTION.SPECIALIZED_UNITS
  const unitSegment = isUnitSection ? thirdSeg : null
  const gradeSlugSegment =
    unitSegment && fourthSeg
      ? fourthSeg
      : !unitSegment && isGradeLikeSlug(thirdSeg)
      ? thirdSeg
      : null

  return {
    variant,
    unitSection: unitSegment || DEFAULT_K8_REPORT_UNIT_SECTION,
    gradeSlugSegment,
  }
}
